import { FaMapMarkerAlt } from "react-icons/fa";
import "../../styles/tour-item.css";

const TourItem = (props) => {
  const { imgUrl, tourName, tourLocation, includedActivities } = props.item;

  const generateWhatsAppLink = (tourName) => {
    const encodedMessage = `Hello from Sankhu Website: I'm enquiring about the ${encodeURIComponent(
      `${tourName}`
    )}. Please advise me on the way forward. Thank you!`;

    return `https://wa.me/254750542046?text=${encodedMessage}`;
  };

  return (
    <div className="card">
      <div className="card__header">
        <div className="card__picture">
          <div className="card__picture-overlay">&nbsp;</div>
          <img className="card__picture-img" src={imgUrl} alt={tourName} />
        </div>
        <h4 className="heading-tertirary">
          <span>{tourName}</span>
        </h4>
      </div>
      <div className="card__details">
        <h4 className="card__sub-heading">
          <FaMapMarkerAlt className="card__icon" />
          {` ${tourLocation}`}
        </h4>
        <p className="card__text">Includes: </p>
        <div className="card__data">
          <ul style={{ listStyleType: "disc" }}>
            {includedActivities.map((activity, index) => (
              <li key={index}>{activity}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="card__footer">
        <button
          className="btn1 btn--green btn--small"
          onClick={() => window.open(generateWhatsAppLink(tourName), "_blank")}
        >
          Enquire
        </button>
      </div>
    </div>
  );
};

export default TourItem;
